// 웹 푸시 토큰 저장·해제
// store(logout) 가 이 파일을 import 하고 store 는 콘솔 번들에도 들어간다.
// 그래서 이 파일은 firebase 를 import 하지 않는다(토큰 받기는 push.js)
//
// 토큰은 브라우저 공통(localStorage), 로그인과 "재등록함" 표시는 탭마다(sessionStorage)다.
// 한 탭이 토큰을 지우면 로그인된 다른 탭은 storage 이벤트로 알고 다시 등록한다(AppMain.vue)

export const TOKEN_KEY = "push-token";
const SYNCED_KEY = "push-synced";

const RELEASE_URL = "/api/push-tokens";
const REGISTRATION_WAIT = 3000;

export function getSavedToken() {
    try {
        return localStorage.getItem(TOKEN_KEY);
    } catch (error) {
        return null;
    }
}

export function saveToken(token) {
    try {
        localStorage.setItem(TOKEN_KEY, token);
    } catch (error) {}
}

// 저장 토큰만 지운다(서버 해제는 보내지 않는다). 지우면 로그인된 다른 탭이 storage 이벤트로 다시 등록한다
export function removeSavedToken() {
    try {
        localStorage.removeItem(TOKEN_KEY);
    } catch (error) {}
}

// 탭당 1회 재등록 표시. 로그아웃 뒤 같은 탭에서 다른 회원이 로그인하면 다시 등록해야 하므로 해제 때 지운다
export function isSynced() {
    try {
        return sessionStorage.getItem(SYNCED_KEY) == "1";
    } catch (error) {
        return false;
    }
}

export function markSynced() {
    try {
        sessionStorage.setItem(SYNCED_KEY, "1");
    } catch (error) {}
}

export function clearSynced() {
    try {
        sessionStorage.removeItem(SYNCED_KEY);
    } catch (error) {}
}

// 이 탭에서 진행 중인 등록(push.js 가 알려 준다). 등록 중에 로그아웃하면 끝난 뒤의 토큰을 지워야 서버에 남지 않는다
let registering = null;

export function setPendingRegistration(promise) {
    registering = promise;
    const clear = () => {
        if (registering === promise) registering = null;
    };
    promise.then(clear, clear);
}

// 로그아웃 때 이 브라우저 토큰을 서버에서 지운다.
// 등록이 진행 중이 아니면 기다리지 않는다(요청은 keepalive 라 화면이 새로 고쳐져도 끝까지 간다).
// 진행 중이면 끝나기를 최대 3초 기다린 뒤 지운다. 3초를 넘기면 등록 쪽(push.js)이 끝난 뒤 스스로 지운다.
// logout 은 1초 타이머·401 처리에서 겹쳐 불릴 수 있으므로 진행 중인 해제를 함께 기다리게 한다
let pending = null;

export function release() {
    if (!pending) pending = releaseOnce().finally(() => (pending = null));
    return pending;
}

async function releaseOnce() {
    if (registering) {
        await Promise.race([registering.catch(() => {}), new Promise((resolve) => setTimeout(resolve, REGISTRATION_WAIT))]);
    }
    releaseSaved();
}

// 저장 토큰을 지우고 서버 해제를 보낸다. 응답은 기다리지 않고 실패는 무시한다.
// 해제는 토큰 값만으로 지우므로(로그인 불필요) Authorization 없이 보낸다
export function releaseSaved() {
    const token = getSavedToken();

    // 해제 요청을 먼저 내보낸 뒤 저장 토큰을 지운다. 지우는 순간 다른 탭이 storage 이벤트로 같은 토큰을 다시 등록하므로,
    // 그 등록보다 해제가 서버에 먼저 닿게 하려는 것이다(다른 탭 쪽은 AppMain.onStorage 에서 조금 늦게 시작한다)
    if (token) {
        try {
            fetch(RELEASE_URL, {
                method: "DELETE",
                keepalive: true,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token }),
            }).catch(() => {});
        } catch (error) {}
    }

    removeSavedToken();
    clearSynced();
}
